"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var VolumeUp = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_VolumeUp_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m4.75 12.5 3.555 3.35a.749.749 0 0 0 1.195-.6V.75c0-.615-.7-.965-1.195-.6L4.75 3.5H3a3 3 0 0 0-3 3v3a3 3 0 0 0 3 3h1.75ZM8.5 1.34 5.436 4.228a1 1 0 0 1-.686.272H3a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1.75a1 1 0 0 1 .686.272L8.5 14.66V1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.146 5.146a.5.5 0 0 1 .708 0 4.036 4.036 0 0 1 0 5.708.5.5 0 0 1-.708-.708 3.035 3.035 0 0 0 0-4.292.5.5 0 0 1 0-.708Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.854 3.146a.5.5 0 0 0-.708.708 5.864 5.864 0 0 1 0 8.293.5.5 0 0 0 .708.707 6.864 6.864 0 0 0 0-9.708Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_VolumeUp_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = VolumeUp;
exports["default"] = _default;